import * as _m0 from "protobufjs/minimal";
import { GetCaseRequest, GetCaseResponse } from "../getcase";
import { withAuthRetry } from '../utils/authRetry';

export async function getcase(request: GetCaseRequest, accessToken: string, setAccessToken: (token: string | null) => void, logout: () => void): Promise<GetCaseResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const encodedRequest = GetCaseRequest.encode(request).finish();

        const params = new URLSearchParams(window.location.search);
        const staging = params.get('stagingEnv') === 'true';

        let url = `https://li68ja5qo4.execute-api.us-west-2.amazonaws.com/intakeservice/getcase?case_id=${request.caseId}`;
        if (staging) {
            const urlParts = url.split('?');
            url = `${urlParts[0]}-staging?${urlParts[1]}`;
        }

        const response = await fetch(
            url, {
            method: 'GET',
            headers,
        }
        );
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): GetCaseResponse => {
        return GetCaseResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}